<template>
  <!-- 密码模态框 -->
  <div class="changePassword">
    <div class="from-table2 develop">
      <div class="row">
        <div class="title">修改密码:</div>
      </div>
    <el-form
      label-position="left"
      label-width="180px"
      :model="userInfopassword"
      status-icon
      :rules="passwordRules"
      ref="userInfopassword"
    >
      <div class="row">
        <el-form-item prop="password1" label="旧密码:">
          <el-input size="mini" type="password" v-model="userInfopassword.password1" placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item></el-form-item>
      </div>
      <div class="row">
        <el-form-item prop="password2" label="新密码:">
          <el-input size="mini" type="password" v-model="userInfopassword.password2" placeholder="密码长度最少6位"></el-input>
        </el-form-item>
        <el-form-item></el-form-item>
      </div>
      <div class="row">
        <el-form-item  prop="password3" label="确认新密码:">
          <el-input size="mini" type="password" v-model="userInfopassword.password3" placeholder="密码长度最少6位"></el-input>
        </el-form-item>
        <el-form-item></el-form-item>
      </div>
        <div class="row">
            <el-form-item>
                <ps-save type="primary" @click="submit('userInfopassword')">确 定</ps-save>
                <ps-close @click="Passwordcolse()">取 消</ps-close>
            </el-form-item>
        </div>
    </el-form>
    </div>
  </div>
</template>

<script>
import { validatePassword } from '@/utils/validate';
import { AuthenticationControllerSvr } from '@/service/AuthenticationControllerSvr.js';
import { mapState ,mapMutations} from 'vuex';
import { encrypt } from '@/utils/encryption.js';
import { removeUser} from '@/utils/auth.js';
export default {
  components: {},
  computed: {
    ...mapState(['token']),
    ...mapMutations(['DEL_TABROUTER'])
  },
  props: { centerDialogVisible: Boolean },
  data() {
    const validatePass1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!validatePassword(value)) {
        callback(new Error('密码长度最少6位'));
      } else {
        if (this.userInfopassword.password3 !== '') {
          this.$refs.userInfopassword.validateField('password3');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (!validatePassword(value)) {
        callback(new Error('密码长度最少6位'));
      } else if (value !== this.userInfopassword.password2) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userInfopassword: {
        password1: '',
        password2: '',
        password3: ''
      },
      DialogVisible: false,
      //密码确认验证
      passwordRules: {

        password1: 
          { 
            required: true, 
            message: '不可为空', 
            trigger: 'blur' 
          },
        password2: 
          {
            required: true,
            validator: validatePass1,
            trigger: 'blur'
          },
        password3: 
          {
            required: true,
            validator: validatePass2,
            trigger: 'blur'
          }
      }
    };
  },
  created() {
    this.AuthenticationControllerSvr = new AuthenticationControllerSvr();
  },
  mounted() {},
  methods: {
    //提交修改
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.AuthenticationControllerSvr.changePassword(
            this.token,
            encrypt(this.userInfopassword.password1),
            encrypt(this.userInfopassword.password2)
          )
            .then(res => {
              this.$message({ type: 'success', message: '修改成功' });
                this.AuthenticationControllerSvr.logout(this.token).then(() => {
                    removeUser();
                    this.$store.commit('SET_TOKEN', null);
                    this.$store.commit('SET_USERINFO', null);
                    this.$router.push('login');
                    location.reload();
                });
              /*this.$emit('close');
              this.resetForm('userInfopassword');*/
            })
            .catch(err => {
              this.$message({
                type: 'error',
                message: '修改失败，初始密码错误'
              });
            });
        } else {
          return false;
        }
      });
    },
    Passwordcolse() {
      this.$emit('close');
      this.resetForm('userInfopassword');
    },
    //重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="scss" scoped>
.changePassword {
  // .from-table2 {
  //   .row {
  //     .el-form-item__label {
  //       padding-right: 10px !important;
  //     }
  //     .el-form-item {
  //       flex: none !important;
  //     }
  //   }
  // }
}
</style>